import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import requests from "../../../../axios/requests";
import { Button, Input, InputNumber, message } from "antd";
import ReuseDropDown from "../../../../components/reuseComponents/ReuseDropDown";
import variableLanguage from "../../../../utils/hooks/hookGetVariablesLanguage";
import AnswerRow from "./AnswerRow";
import { QUESTION_TYPES, initialAnswers, answerPayload, validateQuestion, ANSWER_MAX_COUNT, answerKey, questionImageRequired } from "./quizTypes";

import { ReactComponent as AddQuestion } from "../../../../../images/icons/add_question.svg";
import { ReactComponent as RemoveQuestion } from "../../../../../images/icons/remove_question.svg";
const EditQuiz = (props) => {
    let {setView, stageItems} = props;
    const activeTheme = useSelector((state) => state.Reducer?.activeTheme);
    const isLightTheme = activeTheme === true;

    const containerStyle = isLightTheme
        ? { backgroundColor: "#FFFFFF", padding: 20, borderRadius: 16, position: "relative", border: "1px solid #E2E8F0" }
        : { backgroundColor: "#343843", padding: 20, borderRadius: 16, position: "relative" };
    const labelColor = isLightTheme ? "#64748B" : "#A2AACA";

    const variable_38 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_38"});
    const variable_39 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_39"});
    const variable_40 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_40"});
    const variable_41 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_41"});
    const variable_42 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_42"});
    const variable_43 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_43"});
    const variable_44 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_44"});
    const variable_45 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_45"});
    const variable_46 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_46"});
    const variable_47 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_47"});
    const variable_48 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_48"});
    const variable_49 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_49"});
    const variable_50 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_50"});
    const variable_51 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_51"});
    const variable_52 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_52"});
    const variable_53 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_53"});
    const variable_61 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_61"});
    const variable_62 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_62"});
    const variable_64 = variableLanguage({keyPage: "courseManageEditLesson", keyVariable: "variable_64"});

    const [indexActiveQuestion, setIndexActiveQuestion] = useState(0);
    const [attemptedSave, setAttemptedSave] = useState(false);
    const [quizTitle, setQuizTitle] = useState("");
    const [welcomeText, setWelcomeText] = useState("");
    // Тип теста (block_next=true - контрольный) теперь МОЖНО менять после создания
    // (запрошено пользователем 2026-08-03, как на Staff) -- при сохранении явно
    // отправляем block_next в обе стороны, а не только когда включаем контрольный
    // режим, иначе PATCH (partial update) просто не тронет поле и старое значение
    // останется в БД. При переключении на тренировочный также явно обнуляем
    // attempts/minimal_grade/timer, чтобы не оставлять "хвост" от контрольного
    // режима -- иначе на бэкенде в базе остались бы старые числа, даже если сам
    // block_next=False (и тренировочный тест ими не пользуется).
    const [isControlMode, setIsControlMode] = useState(false);
    const [countAttemps, setCountAttemps] = useState(1);
    const [minThreshold, setMinThreshold] = useState(75);
    const [timerMinutes, setTimerMinutes] = useState(0);
    const [timerSeconds, setTimerSeconds] = useState(0);
    const [activeRecomendation, setActiveRecomendation] = useState(0);
    const [questions, setQuestions] = useState([]);
    const [arrRemoveAnswers, setArrRemoveAnswers] = useState([]);
    const [arrRemoveQuestions, setArrRemoveQuestions] = useState([]);
    const [objRecomendation, setObjRecomendation] = useState([]);
    const [render, setRender] = useState(1);

    const [flagDropEdit, setFlagDropEdit] = useState(false);
    const [flagOpenRecomendation, setFlagOpenRecomendation] = useState(false);
    const [flagOpenQuestionType, setFlagOpenQuestionType] = useState(false);
    const [flagOpenTypeDropDown, setFlagOpenTypeDropDown] = useState(false);

    let apiChangeQuiz = () => {
        if (!quizTitle) return message.error(variable_38);
        if (questions.length === 0) return message.error(variable_39);
        for (let i = 0; i < questions.length; i++) {
            if (!questions[i].title) {
                setIndexActiveQuestion(i);
                return message.error(variable_40);
            }
            const error = validateQuestion(questions[i]);
            if (error === "missing_text") {
                setIndexActiveQuestion(i);
                setAttemptedSave(true);
                return message.error(variable_41);
            }
            if (error === "missing_image") {
                setIndexActiveQuestion(i);
                setAttemptedSave(true);
                return message.error("Добавьте картинку ко всем вариантам ответа - или уберите её везде");
            }
            if (error === "no_correct") {
                setIndexActiveQuestion(i);
                return message.error(variable_42);
            }
        }
        let changePayload = {title: quizTitle, welcome_text: welcomeText, block_next: isControlMode};
        if (isControlMode) {
            changePayload.attempts = countAttemps;
            changePayload.minimal_grade = minThreshold;
            changePayload.timer = timerMinutes * 60 + timerSeconds;
        } else {
            // Явно очищаем, а не просто оставляем PATCH их не трогать -- иначе
            // переключение обратно в контрольный подхватило бы старые числа
            // предыдущего контрольного режима вместо разумных значений по умолчанию.
            changePayload.attempts = null;
            changePayload.minimal_grade = null;
            changePayload.timer = null;
        }
        requests.stages
            .change_stages_matherial(stageItems.id, changePayload)
            .then((response) => {
                message.success(variable_43);
                setTimeout(() => {
                    setView();
                }, 1000);
            })
            .catch((e) => console.error(e));

        let arrCreateQuestions = [];
        let arrChangeQuestions = [];
        let objCreateAnswers = {
            answers: [],
            idQuestion: null
        };
        let objChangeAnswers = {
            answers: [],
            idQuestion: null
        };
        for (let i = 0; i < questions.length; i++) {
            if (typeof questions[i].id === "undefined")
                arrCreateQuestions = [...arrCreateQuestions, questions[i]];
            else
                arrChangeQuestions = [...arrChangeQuestions, questions[i]];

            const type = questions[i].type || "single";
            for (let j = 0; j < questions[i].answers.length; j++) {
                if (typeof questions[i].answers[j].id === "undefined") {
                    if (typeof questions[i].id !== "undefined") {
                        questions[i].answers[j].question_id = questions[i].id;
                        questions[i].answers[j]._type = type;
                        questions[i].answers[j]._sortOrder = j + 1;
                        objCreateAnswers.answers.push(questions[i].answers[j]);
                        objCreateAnswers.idQuestion = questions[i].id;
                    }
                } else {
                    questions[i].answers[j]._type = type;
                    questions[i].answers[j]._sortOrder = j + 1;
                    objChangeAnswers.answers.push(questions[i].answers[j]);
                    objChangeAnswers.idQuestion = questions[i].id;
                }
            }
        }
        // answers create   // создание ответов к вопросам имеющим id
        if (objCreateAnswers.answers.length > 0) {
            let answersArr = [];
            for (let i = 0; i < objCreateAnswers.answers.length; i++) {
                const item = objCreateAnswers.answers[i];
                let objAnsw = {
                    "question": item.question_id,
                    ...answerPayload(item._type, item, item._sortOrder),
                };
                answersArr = [...answersArr, objAnsw];
            }
            requests.quiz.create_answers(answersArr)
                .catch((err) => console.error(err));
        }
        // answers change
        if (objChangeAnswers.answers.length > 0) {
            for (let i = 0; i < objChangeAnswers.answers.length; i++) {
                const item = objChangeAnswers.answers[i];
                let objAnsw = answerPayload(item._type, item, item._sortOrder);
                requests.quiz.change_answers(item.id, objAnsw)
                    .catch((err) => console.error(err));
            }
        }
        // answers remove
        if (arrRemoveAnswers.length > 0) {
            for (let i = 0; i < arrRemoveAnswers.length; i++) {
                requests.quiz.remove_answers(arrRemoveAnswers[i])
                    .catch(err => console.error(err));
            }
        }
        // questions create
        if (arrCreateQuestions.length > 0) {
            let questionsArr = [];
            let answersArr = [];
            for (let i = 0; i < arrCreateQuestions.length; i++) {
                let obj = {
                    "quiz": stageItems.id,
                    "title": arrCreateQuestions[i].title,
                    "type": arrCreateQuestions[i].type || "single",
                };
                questionsArr = [...questionsArr, obj];
            }
            requests.quiz.create_question(questionsArr)
                .then((res) => {
                    let idQuestion = res.data;
                    for (let i = 0; i < idQuestion.length; i++) {
                        const type = arrCreateQuestions[i].type || "single";
                        for (let j = 0; j < arrCreateQuestions[i].answers.length; j++) {
                            let objAnsw = {
                                "question": idQuestion[i].id,
                                ...answerPayload(type, arrCreateQuestions[i].answers[j], j + 1),
                            };
                            answersArr = [...answersArr, objAnsw];
                        }
                    }
                    requests.quiz.create_answers(answersArr)
                        .catch((err) => console.error(err));
                });
        }
        // questions change
        if (arrChangeQuestions.length > 0) {
            for (let i = 0; i < arrChangeQuestions.length; i++) {
                let obj = {
                    "title": arrChangeQuestions[i].title,
                };
                requests.quiz.change_question(arrChangeQuestions[i].id, obj)
                    .then((res) => {
                    });
            }
        }
        // questions remove
        if (arrRemoveQuestions.length > 0) {
            for (let i = 0; i < arrRemoveQuestions.length; i++) {
                requests.quiz.remove_questions(arrRemoveQuestions[i])
                    .then((res) => {
                    })
                    .catch(err => console.error(err));
            }
        }
        // recomendation create
        if (activeRecomendation === 1 && typeof objRecomendation[0].id === "undefined") {
            let objRec = {
                "quiz": stageItems.id,
                "low": objRecomendation[0].low,
                "middle": objRecomendation[0].middle,
                "high": objRecomendation[0].high
            };
            requests.quiz.create_recomendations([objRec])
                .then((res) => {
                })
                .catch(err => console.error(err));
        }
        //recomendation change
        if (activeRecomendation === 1 && objRecomendation[0].id) {
            let obj = {
                "low": objRecomendation[0].low,
                "middle": objRecomendation[0].middle,
                "high": objRecomendation[0].high
            };
            requests.quiz.change_recomendations(objRecomendation[0].id, obj)
                .then((res) => {
                })
                .catch(err => console.error(err));
        }
        // recomendation remove
        if (activeRecomendation === 0 && objRecomendation.length > 0) {
            if (typeof objRecomendation[0].id !== "undefined") {
                requests.quiz.remove_recomendations(objRecomendation[0].id)
                    .then((res) => {
                    })
                    .catch(err => console.error(err));
            }
        }
    };

    useEffect(() => {
        if (stageItems.quiz_responses.length > 0) {
            setObjRecomendation(stageItems.quiz_responses);
            setActiveRecomendation(1);
        } else {
            setObjRecomendation([{
                "low": "",
                "middle": "",
                "high": ""
            }]);
        }
    }, [stageItems.quiz_responses]);
    useEffect(() => {
        setQuizTitle(stageItems.title);
        setWelcomeText(stageItems.welcome_text || "");
        setQuestions(stageItems.questions);
        setIsControlMode(!!stageItems.block_next);
        setCountAttemps(stageItems.attempts || 1);
        // 100, не 75 - именно так interprets отсутствие minimal_grade весь остальной
        // код (студенческий экран, превью учителя): "порог не задан" = 100%. Если
        // тут подставить другое число, а учитель сохранит не заметив - порог
        // прохождения задним числом реально станет ниже (QA 2026-07-27).
        setMinThreshold(stageItems.minimal_grade || 100);
        setTimerMinutes(Math.floor((stageItems.timer || 0) / 60));
        setTimerSeconds((stageItems.timer || 0) % 60);
    }, [stageItems]);
    return (
        <div className={"edit_quiz"}>
            <div style={containerStyle}>
                <div style={{color: labelColor, margin: "5px 0 5px 15px"}}>{variable_44}</div>
                <Input
                    className={"input_classic"}
                    value={quizTitle}
                    onChange={(e) => setQuizTitle(e.target.value)}
                    maxLength={99}
                />
                <div style={{color: labelColor, margin: "10px 0 5px 15px"}}>Приветственное слово</div>
                <Input.TextArea
                    className={"textarea_antd"}
                    value={welcomeText}
                    onChange={(e) => setWelcomeText(e.target.value)}
                    placeholder="Приветственное слово"
                    style={{marginTop: 0}}
                />
                <div style={{color: labelColor, margin: "10px 0 5px 15px"}}>{variable_64}</div>
                <ReuseDropDown
                    flagOpen={flagOpenTypeDropDown}
                    setFlagOpen={(bool) => setFlagOpenTypeDropDown(bool)}
                    arrList={[variable_61, variable_62]}
                    activeArrList={isControlMode ? 1 : 0}
                    setActiveArrList={(indx) => setIsControlMode(indx === 1)}
                />
                {isControlMode &&
                    <>
                        <div className="quiz_edit_warning">
                            Это контрольный тест. Если его уже кто-то проходил, изменение попыток,
                            порога прохождения или переключение обратно на тренировочный задним
                            числом сделает уже выставленные результаты несогласованными с новыми
                            настройками - меняйте с осторожностью.
                        </div>
                        <div style={{display: "flex", gap: 15, flexWrap: "wrap", margin: "0 0 0 15px"}}>
                            <div className={"count_resp"}>
                                <span>Попыток</span>
                                <InputNumber
                                    size="small"
                                    min={1}
                                    max={10}
                                    value={countAttemps}
                                    onChange={(e) => setCountAttemps(e)}
                                />
                            </div>
                            <div className={"count_resp"}>
                                <span>Порог прохождения</span>
                                <InputNumber
                                    size="small"
                                    min={1}
                                    max={100}
                                    value={minThreshold}
                                    onChange={(e) => setMinThreshold(e)}
                                />
                                <span>%</span>
                            </div>
                            <div className={"count_resp"}>
                                <span>Минуты</span>
                                <InputNumber
                                    size="small"
                                    min={0}
                                    value={timerMinutes}
                                    onChange={(e) => setTimerMinutes(e || 0)}
                                />
                            </div>
                            <div className={"count_resp"}>
                                <span>Секунды</span>
                                <InputNumber
                                    size="small"
                                    min={0}
                                    max={59}
                                    value={timerSeconds}
                                    onChange={(e) => setTimerSeconds(e || 0)}
                                />
                            </div>
                        </div>
                    </>
                }
                <div style={{color: labelColor, margin: "10px 0 5px 15px"}}>{variable_45}</div>
                <div className="row_navigation-questions">
                    {Array(questions.length).fill(0).map((_, indx) =>
                        <div
                            className={indexActiveQuestion === indx ? "number active" : "number"}
                            key={indx}
                            onClick={() => {
                                setIndexActiveQuestion(indx);
                            }}
                        >
                            <span>{indx + 1}</span>
                        </div>
                    )}
                    <div
                        onClick={() => {
                            let newArr = [...questions];
                            newArr.push(
                                {
                                    type: "single",
                                    answers: initialAnswers("single"),
                                    title: ""
                                }
                            );
                            setQuestions(newArr);
                            setIndexActiveQuestion(prev => {
                                if (questions.length > 0) {
                                    return questions.length;
                                } else return 0;
                            });
                        }}
                        className="create_question"
                    >
                        <AddQuestion/>
                    </div>
                    {questions.length > 0 &&
                        <div
                            onClick={() => {
                                let newArr = [...questions];
                                newArr.splice(indexActiveQuestion, 1);
                                setQuestions(newArr);
                                if (indexActiveQuestion !== 0) {
                                    setIndexActiveQuestion((prev) => prev - 1);
                                }
                                setArrRemoveQuestions((prev) => [...prev, questions[indexActiveQuestion].id]);
                            }}
                            className="remove_question"
                        >
                            <RemoveQuestion/>
                        </div>
                    }
                </div>
                {questions && questions.length > 0 &&
                    <>
                        <div style={{color: labelColor, margin: "10px 0 5px 15px"}}>Тип вопроса</div>
                        {typeof questions[indexActiveQuestion].id === "undefined"
                            ? <ReuseDropDown
                                flagOpen={flagOpenQuestionType}
                                setFlagOpen={(bool) => setFlagOpenQuestionType(bool)}
                                arrList={QUESTION_TYPES}
                                activeArrList={QUESTION_TYPES.findIndex((t) => t.type === (questions[indexActiveQuestion].type || "single"))}
                                setActiveArrList={(indx) => {
                                    let newArr = [...questions];
                                    const type = QUESTION_TYPES[indx].type;
                                    newArr[indexActiveQuestion].type = type;
                                    newArr[indexActiveQuestion].answers = initialAnswers(type);
                                    setQuestions(newArr);
                                }}
                              />
                            : <div style={{margin: "0 0 10px 15px", color: labelColor}}>
                                {QUESTION_TYPES.find((t) => t.type === (questions[indexActiveQuestion].type || "single"))?.name}
                                {" "}(тип существующего вопроса не меняется)
                              </div>}
                        <div className="question_title" style={{position: "relative"}}>
                            <div style={{color: labelColor, margin: "10px 0 5px 15px"}}>{variable_46}</div>
                            <Input
                                value={questions[indexActiveQuestion].title}
                                onChange={(e) => {
                                    let newArr = [...questions];
                                    questions[indexActiveQuestion].title = e.target.value;
                                    setQuestions(newArr);
                                }}
                                className={"input_classic"}
                                size="large"
                                placeholder={variable_47}
                                style={{marginBottom: "10px"}}
                            />
                        </div>
                        <div className={
                            (questions[indexActiveQuestion].type || "single") === "single"
                                ? "answers_list answers_list--cards"
                                : "answers_list"
                        }>
                        {questions[indexActiveQuestion].answers.map((el, ind) => {
                            let funcViewAddAnswerIcon = () => {
                                if (questions[indexActiveQuestion].answers.length - 1 == ind)
                                    return questions[indexActiveQuestion].answers.length < ANSWER_MAX_COUNT;
                            };
                            const type = questions[indexActiveQuestion].type || "single";
                            return (
                                <AnswerRow
                                    key={answerKey(el)}
                                    imageRequired={questionImageRequired(questions[indexActiveQuestion])}
                                    showErrors={attemptedSave}
                                    type={type}
                                    el={el}
                                    index={ind + 1}
                                    setCheckbox={(e) => {
                                        let newArr = [...questions];
                                        newArr[indexActiveQuestion].answers[ind].correct = e;
                                        setQuestions(newArr);
                                    }}
                                    setText={(e) => {
                                        let newArr = [...questions];
                                        newArr[indexActiveQuestion].answers[ind].text = e;
                                        setQuestions(newArr);
                                    }}
                                    setPairItem={(e) => {
                                        let newArr = [...questions];
                                        newArr[indexActiveQuestion].answers[ind].pair_item = e;
                                        setQuestions(newArr);
                                    }}
                                    setImage={(thumbBase64, fullBase64) => {
                                        let newArr = [...questions];
                                        newArr[indexActiveQuestion].answers[ind].img_question_base64 = thumbBase64;
                                        newArr[indexActiveQuestion].answers[ind].img_question_full_base64 = fullBase64;
                                        setQuestions(newArr);
                                    }}
                                    removeImage={() => {
                                        let newArr = [...questions];
                                        const answer = newArr[indexActiveQuestion].answers[ind];
                                        answer.img_question = "";
                                        answer.img_question_base64 = "";
                                        answer.img_question_full = "";
                                        answer.img_question_full_base64 = "";
                                        setQuestions(newArr);
                                    }}
                                    placeholder={`${variable_48} ` + (ind + 1)}
                                    removeAnswer={(id) => {
                                        let newArr = [...questions];
                                        newArr[indexActiveQuestion].answers.splice(ind, 1);
                                        setQuestions(newArr);
                                        if (id) setArrRemoveAnswers((prev) => [...prev, id]);
                                    }}
                                    setAddAnswer={() => {
                                        let newArr = [...questions];
                                        if (questions[indexActiveQuestion].answers.length < ANSWER_MAX_COUNT) {
                                            newArr[indexActiveQuestion].answers.push(initialAnswers(type)[0]);
                                            setQuestions(newArr);
                                        }
                                    }}
                                    viewAddAnswerIcon={funcViewAddAnswerIcon()}
                                    viewRemoveAnswerIcon={questions[indexActiveQuestion].answers.length > 2 ? true : false}
                                />
                            );
                        })}
                        </div>
                    </>
                }
                <div className="recomenditon">
                    <div className="group_drop-down">
                        <div style={{color: labelColor, margin: "15px 0 5px 15px", zIndex: 4}}>{variable_49}</div>
                        <ReuseDropDown
                            flagOpen={flagOpenRecomendation}
                            setFlagOpen={(bool) => setFlagOpenRecomendation(bool)}
                            arrList={[variable_50, variable_51]}
                            activeArrList={activeRecomendation}
                            setActiveArrList={(indx) => setActiveRecomendation(indx)}
                        />
                    </div>

                    {activeRecomendation === 1 && objRecomendation.length > 0
                        && <>
                            <Input.TextArea
                                value={objRecomendation[0].low}
                                onChange={(e) => {
                                    let newArr = [...objRecomendation];
                                    newArr[0].low = e.target.value;
                                    setObjRecomendation(newArr);
                                }}
                                placeholder={`${variable_52} 0 - 33%`}
                                className={"textarea_antd"}
                                style={{marginTop: 0}}
                            />
                            <Input.TextArea
                                value={objRecomendation[0].middle}
                                onChange={(e) => {
                                    let newArr = [...objRecomendation];
                                    newArr[0].middle = e.target.value;
                                    setObjRecomendation(newArr);
                                }}
                                className={"textarea_antd"}
                                placeholder={`${variable_52} 34 - 66%`}
                            />
                            <Input.TextArea
                                value={objRecomendation[0].high}
                                onChange={(e) => {
                                    let newArr = [...objRecomendation];
                                    newArr[0].high = e.target.value;
                                    setObjRecomendation(newArr);
                                }}
                                className={"textarea_antd"}
                                placeholder={`${variable_52} 67 - 100%`}
                            />
                        </>}
                </div>
                <div className="buttonWithCount">
                    <Button
                        className={"btn_save"}
                        onClick={() => apiChangeQuiz()}
                    >
                        {variable_53}
                    </Button>
                </div>
            </div>
            <div className="render" style={{opacity: 0, position: "absolute"}}>{render}</div>
            <div
                className={flagDropEdit ? "overlay open" : "overlay"}
                onClick={() => {
                    setFlagDropEdit(false);
                }}
            />
        </div>
    );
};
export default React.memo(EditQuiz);


